import { render, staticRenderFns } from "./LandingRegionGroup.vue?vue&type=template&id=4e1ffb2f&scoped=true"
import script from "./LandingRegionGroup.vue?vue&type=script&lang=js"
export * from "./LandingRegionGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1ffb2f",
  null
  
)

export default component.exports